
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";
import IrbGptSection from "@/components/sections/IrbGptSection.vue";

interface IStep1 {
  question: string;
  researchDesign: string;
  otherResearchDesign: string;
  isAnyIntervention: string;
  sumarizeIntervention: string;
  outcomes: string;
}

export default defineComponent({
  name: "step-3",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
    IrbGptSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step1 = ref<IStep1>({
      question: "",
      researchDesign: "",
      otherResearchDesign: "",
      isAnyIntervention: "",
      sumarizeIntervention: "",
      outcomes: "",
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      console.log(data);
      step1.value.question =
        data.data.question != null && data.data.question != undefined
          ? data.data.question
          : "";
      step1.value.researchDesign =
        data.data.researchDesign != null &&
        data.data.researchDesign != undefined
          ? data.data.researchDesign
          : "";
      step1.value.otherResearchDesign =
        data.data.otherResearchDesign != null &&
        data.data.otherResearchDesign != undefined
          ? data.data.otherResearchDesign
          : "";
      step1.value.isAnyIntervention =
        data.data.isAnyIntervention != null &&
        data.data.isAnyIntervention == true
          ? "1"
          : "";
      step1.value.sumarizeIntervention =
        data.data.sumarizeIntervention != null &&
        data.data.sumarizeIntervention != undefined
          ? data.data.sumarizeIntervention
          : "";
      step1.value.outcomes =
        data.data.outcomes != null && data.data.outcomes != undefined
          ? data.data.outcomes
          : "";
    });

    return {
      step1,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
